export default __webpack_public_path__ + "static/media/rh-consultants.b0ce20fe.svg";